type PlatformId = "web" | "android" | "ios";
const id: PlatformId = process.env.REACT_APP_PLATFORM as PlatformId;

export default {
  id,
  isWeb: () => id === "web",
  isAndroid: () => id === "android",
  isIos: () => id === "ios",
};
